import { type Experimental_DefaultFormStateBehavior, type RJSFSchema } from '@rjsf/utils'
import { customizeValidator } from '@rjsf/validator-ajv8'
import { type ParametersFormContext } from '../formContext'
import { type JsonObject } from '../mergePatch'

export const parametersValidator = customizeValidator<JsonObject, RJSFSchema, ParametersFormContext>({
  ajvOptionsOverrides: { keywords: [{ keyword: 'zocksReference' }, { keyword: 'zocksUi' }] },
})

export const PARAMETERS_DEFAULT_FORM_STATE: Experimental_DefaultFormStateBehavior = {
  arrayMinItems: { populate: 'requiredOnly' },
  constAsDefaults: 'skipOneOf',
}
